import { render, staticRenderFns } from "./GroupBulkShelvesContent.vue?vue&type=template&id=ee36f5a6&scoped=true"
import script from "./GroupBulkShelvesContent.vue?vue&type=script&lang=js"
export * from "./GroupBulkShelvesContent.vue?vue&type=script&lang=js"
import style0 from "./GroupBulkShelvesContent.vue?vue&type=style&index=0&id=ee36f5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee36f5a6",
  null
  
)

export default component.exports